import React from 'react';

// redux
import { useSelector } from 'react-redux';
import { selectDepartureCount, selectDepartureSkip } from '_redux/slices/prm-bookings/departures'
import { selectArrivalsCount, selectArrivalsSkip } from '_redux/slices/prm-bookings/arrivals'
import { selectBookingTableType, } from '_redux/slices/prm-bookings/bookings-table'


// exterior libraries
import { Subtitle } from '@tremor/react';

const TableCount = (props) => {

    // type of table
    const type = useSelector(selectBookingTableType);

    // states
    const limit = 100;

    // counts
    const departuresCount = useSelector(selectDepartureCount);
    const arrivalsCount = useSelector(selectArrivalsCount);
    const arrivalsSkip = useSelector(selectArrivalsSkip)
    const departuresSkip = useSelector(selectDepartureSkip)

    return (
        <Subtitle>
            {type == 'Departures' ? departuresSkip : arrivalsSkip} - {type == 'Departures' ? (departuresSkip + limit > departuresCount ? departuresCount : departuresSkip + limit) : (arrivalsSkip + limit > arrivalsCount ? arrivalsCount : arrivalsSkip + limit)} of { type == 'Departures' ? departuresCount : arrivalsCount}
        </Subtitle>
    );
};

export default TableCount;